// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fax-success-notification {\n  width: 450px !important;\n}\n.fax-success-notification .el-notification__content {\n  margin-top: 10px;\n}", ""]);
// Exports
module.exports = exports;
